'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper.js');
var Border = require('../common/Border');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var convertHelper = require('../../types/convertHelper');
var Dom = require('react-dom');
var util = require('../../helper/util');
var _ = require('underscore');

var RuntimeOptions = require('../RuntimeOption.js');
var linkHelper = require('../common/LinkHelper');
var appTypes = require('../../types/appTypes');

var TextInput = React.createClass({

  _doPaint: function () {
    var com;
    var parentDom;
    var size;

    if (this.props.isAutoSize) {
      com = Dom.findDOMNode(this);
      parentDom = com.parentElement;

      while (!parentDom && (parentDom.id !== this.props.controlID)) {
        parentDom = parentDom.parentElement;
      }
      if (parentDom) {
        size = AutoSizeHelper.getComAutoSize(this.props);
        parentDom.style.width = size.width + 6 + 'px';
        parentDom.style.height = size.height + 8 + 'px';
      }
    }
  },

  componentDidMount: function () {
    this._doPaint();
  },

  render: function () {
    var haveAction = false;
    var isLink = false;
    var className = 'no-link';
    var actionDatas = [];

    if(this.props.interactiveData || this.props.links) {
      actionDatas = linkHelper.parseComInteractive(this.props)
    }

    this.actionData = actionDatas[0] || {};
    haveAction = this.actionData.externalURL || this.actionData.link || this.actionData.entry;
    isLink = this.actionData.externalURL || this.actionData.link;

    var linkStyle = {
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      userSelect: 'none',
      position: 'absolute',
      //此处链接区域应该置于上层
      //注意检查：改动该属性是否有副作用
      zIndex: 800,
      pointerEvents: 'none'
    };
    if (haveAction) {
      if (isLink) {
        className = 'page-link'
      } else {
        className = 'interactive-link'
      }
    }

    return (<div
      onClick={this._onClick}
      onMouseDown={this._onMouseDown}
      onMouseUp={this._onMouseUp}
      onDoubleClick={this._onDblClick}
      onContextMenu={this._onContentMenu}>
      {this.renderInput()}
      {
        haveAction && (
          <div className={className}
               style={linkStyle}
          ></div>
        )
      }
    </div>)
  },

  renderInput: function () {
    var h = styleHelper.getHeight(this.props);
    var w = styleHelper.getWidth(this.props);
    var inputStyle = {
      position: 'absolute',
      zIndex: 2,
      width: w,
      height: h,
      border: 'none',
      paddingLeft: 2,
      paddingRight: 2,
      margin: 0,
      boxSizing: 'border-box',
      outline: 'none',
      lineHeight: h - 2 + 'px'
    };
    var placeHolder = this.props.placeHolder;
    if (typeof placeHolder !== 'string') {
      placeHolder = '';
    }
    var text = this.state.text;
    styleHelper.StyleUtil(this.props, inputStyle).align().text().background().border();
    inputStyle.paddingLeft += inputStyle.borderRadius || 0;
    if (_.isUndefined(this.props.canInput) || this.props.canInput) {
      return (
        <input
          ref="input"
          value={text}
          style={inputStyle}
          onChange={this.onChange}
          onBlur={this.onBlur}
          type={this.getInputType()}
          placeholder={placeHolder}
        />

      );
    } else {
      return (
        <input
          ref="input"
          disabled
          value={text}
          style={inputStyle}
          type={this.getInputType()}
          placeholder={placeHolder}/>

      );
    }
  },

  getInputType: function () {
    return this.props.inputModel === 'emPassword' ? 'password' : 'text';
  },

  onChange: function (e) {
    var text = this.tranText(e.target.value);
    //var text = e.target.value;
    //if(!this.validateNumber(text)) {      //验证是否合法数字输入
    //text = this.state.text;
    //}
    this.setState({text: text, update: !this.state.update});
  },

  onBlur: function() {
    this.setState({text: this.state.text.trim(), update: !this.state.update});
  },

  //数字输入框时，屏蔽编辑情景中的不合法输入
  tranText: function (text) {
    if (this.props.inputModel === 'emNumber') {
      var t = text.charAt(0);
      //中文句号转换为英文点
      text = text.replace(/。/g, ".");
      //先把非数字的都替换掉，除了数字和.
      text = text.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      text = text.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      text = text.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      text = text.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      //如果第一位是负号，则允许添加  如果不允许添加负号 可以把这块注释掉
      if (t === '-') {
        text = '-' + text;
      }
    }
    return text;
  },

  validateNumber: function (text) {
    //判断是否为数字的正则，与桌面端保持一致
    var r = /^-?([1-9]+\d*|0)\.?\d*$/;
    //空文本情况也是做合法输入
    return r.test(text) || text === '';
  },

  setTextInteractiveNum: 0,
  componentWillReceiveProps: function (newProps) {
    var text = styleHelper.getText(newProps);
    text = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(text));
    var num = newProps.setTextInteractiveNum || 0;

    //此处只有文本框被设置文本交互时才更新
    //解析设置文本交互时记录了触发设置文本的次数
    //不触发新的设置文本交互，不更新text
    if (num !== this.setTextInteractiveNum) {
      this.setTextInteractiveNum = num;
      if (this.props.inputModel === 'emNumber') {
        text = this.validateNumber(text) ? text : '123';    //不合法文本置为默认值123
      }
      this.setState({text: text});
    }
  },

  getInitialState: function () {
    return {
      text: styleHelper.getText(this.props),
      update: false,
    }
  },


  _onContentMenu: function (e) {
    e.nativeEvent.returnValue = false;
    return false;
  },

  _onLinkEvent: function (evt, linkKey) {
    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
    this.props.events.doSelfClick(evt, this.props, linkKey, 0);
  },

  _onClick: function (e) {
    var key;
    if (this.longPress) {
      return;
    }
    if (e.button === 0) {
      if (this.actionData.externalURL) {
        key = appTypes.ActionResponseType.OUTER;
      } else if (this.actionData.link) {
        key = appTypes.ActionResponseType.LINK;
      } else if (this.actionData.entry) {
        key = appTypes.ActionResponseType.INTERACTIVE;
      }
      if (key) {
        this._onLinkEvent(e, key);
      }
    } else if (e.button === 2) {
      this._onRightClick(e);
    }
  },

  _onLongPress: function (evt) {
    if (this.props.events.doSelfLongPress)
      this.props.events.doSelfLongPress(evt, this.props, 0)
  },

  _onRightClick: function (evt) {
    if (this.props.events.doSelfRightClick) {
      this.props.events.doSelfRightClick(evt, this.props, 0);
    }
  },

  _onDblClick: function (evt) {
    if (this.props.events.doSelfDbClick) {
      this.props.events.doSelfDbClick(evt, this.props, 0);
    }
  },

  _onMouseDown: function (e) {
    if(this.props.canInput) {
      e.stopPropagation();
    }
    if (e.button === 0) {
      this.mousePress = true;
      this._startLongPress(e);
    } else if (e.button === 2) {
      this._onRightClick(e);
    }
  },

  _onMouseUp: function (e) {
    if(this.props.canInput) {
      e.stopPropagation();
    }
    this.mousePress = false;
    this._stopLongPress();
  },
  _startLongPress: function (e) {
    var self = this;
    self.longPress = false;
    if (linkHelper.hasLongPressEvents(this.props.interactiveData, 0)) {
      this.longPressTimeID = setTimeout(function () {
        if (self.mousePress) {
          self.longPress = true;
          self._onLongPress(e);
        }
        self._stopLongPress();
      }, 800);
    }
  },

  _stopLongPress: function () {
    if (this.longPressTimeID) {
      clearTimeout(this.longPressTimeID)
    }
    delete this.longPressTimeID;
  }

});

module.exports = TextInput;



// WEBPACK FOOTER //
// ./src/views/Components/TextInput.jsx